import { connect as defaultConnect } from 'react-redux'
import { Connect } from '@sendoutcards/core'

import { State } from 'src/redux/reducers'

export const connect: Connect<State> = defaultConnect

export default connect
